import React from "react";

interface SvgIconProps {
    className?: string;
    size?: number;
}

export function ModernStarRatingClearIcon({ className, size = 16 }: SvgIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={size}
            width={size}
            viewBox="0 -960 960 960"
            fill="currentColor"
            className={className}
            aria-hidden="true"
        >
            <path d="M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z" />
        </svg>
    );
}
